import { NotOverridableSponsorBannerKeysType } from "../_interfaces";

export const NotOverridableSponsorBannerKeys: NotOverridableSponsorBannerKeysType[] = [
    't1-tournaments-top',
    't1-tournaments-presenting',
    't1-tournaments-completed'
];